module.exports = __webpack_public_path__ + "static/media/x_inactive.2aa9da34.svg";